import React, { useMemo } from 'react';
import { Card, Table, Typography, Tag } from 'antd';
import { mockWebsites } from '../Super Admin/mockData';

const { Title, Text } = Typography;

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
  { title: 'Domain', dataIndex: 'url', key: 'url' },
  { title: 'Status', dataIndex: 'status', key: 'status', width: 140, render: (s) => <Tag color={s === 'active' ? 'green' : 'default'}>{s}</Tag> },
  { title: 'Created', dataIndex: 'created_at', key: 'created_at', width: 220, render: (t) => new Date(t).toLocaleString() },
];

const ViewerWebsites = () => {
  const dataSource = useMemo(() => mockWebsites.map(w => ({ ...w, key: w.id })), []);
  return (
    <div>
      <Title level={2} style={{ marginBottom: 16 }}>Websites (View Only)</Title>
      <Card style={{ borderRadius: 14 }}>
        <Text type="secondary">You can view the list of websites. Editing is disabled.</Text>
        <Table style={{ marginTop: 12 }} columns={columns} dataSource={dataSource} pagination={{ pageSize: 5 }} />
      </Card>
    </div>
  );
};

export default ViewerWebsites;
